import styled from 'styled-components';
import Collapsible from 'react-collapsible';
import { FlexAlignCenterSpaceBetween } from 'components/primitives/flex';
import { Box } from 'components/primitives/box';

export default function CollapsibleFilter({ headerContent, children, openByDefault = false }) {
  return (
    <Collapsible
      transitionTime={200}
      open={openByDefault}
      trigger={
        <Header gap="1em">
          {headerContent}
          <CollapseArrow />
        </Header>
      }
    >
      <Box mt="32px">{children}</Box>
    </Collapsible>
  );
}

const Header = styled(FlexAlignCenterSpaceBetween)`
  cursor: pointer;
`;

const CollapseArrow = styled(ArrowDownCollapseIcon)`
  .Collapsible__trigger & {
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
  .Collapsible__trigger.is-open & {
    transform: rotate(180deg);
  }
`;

export function ArrowDownCollapseIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008" width={16} height={16} {...props}>
      <path d="M875.4 349.4c0 6.6-4 13.2-7.9 17.2L521.2 712.8c-4 4-11.9 7.9-17.2 7.9-6.6 0-13.2-4-17.2-7.9L140.5 366.6c-4-4-7.9-10.6-7.9-17.2 0-5.3 4-13.2 7.9-17.2l37-37c4-4 10.6-7.9 17.2-7.9 5.3 0 13.2 4 17.2 7.9L504 587.3l292.1-292.1c4-4 11.9-7.9 17.2-7.9 6.6 0 13.2 4 17.2 7.9l37 37c3.9 4 7.9 11.9 7.9 17.2z" />
    </svg>
  );
}
